import * as React from 'react';
import './Legend.css';

const Legend = () => {
  const colors = [
    {
      deathLabel: '1980-2002',
      color: '#1b9e77'
    },
    {
      deathLabel: '1970-1980',
      color: '#d95f02'
    },
    {
      deathLabel: '1960-1970',
      color: '#7570b3'
    },
    {
      deathLabel: '1950-1960',
      color: '#e7298a'
    },
    {
      deathLabel: '1940-1950',
      color: '#66a61e'
    },
    {
      deathLabel: '1920-1940',
      color: '#e6ab02'
    },
    {
      deathLabel: 'before 1920',
      color: '#666666'
    },
    {
      deathLabel: 'unknown date',
      color: '#8D5649'
    },
    {
      deathLabel: 'uncertain location',
      color: '#D8241F'
    },
  ];

  return (
    <div id='legend'>
      Date of death
      <br />


      { colors.reverse().map(d => (
        <div
          key={d.deathLabel}
        >
          <svg
            width={16}
            height={12}
          >
            <circle
              cx={6}
              cy={6}
              r={5}
              stroke='black'
              fill={d.color}
            />
          </svg>
          {d.deathLabel}
        </div>
      ))}
    </div>
  );
};

export default Legend;



// WEBPACK FOOTER //
// ./src/components/Legend.jsx